import { render, staticRenderFns } from "./SubEvents.vue?vue&type=template&id=7c1636b2"
import script from "./SubEvents.vue?vue&type=script&lang=js"
export * from "./SubEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports